import React, { useEffect } from 'react';
import { Dialog } from '@mui/material';
import EditDefineLeaves from './EditDefineLeaves';
import AddDefineLeaves from './AddDefineLeaves';

const ToggleModal = ({
  open,
  toggle,
  isEdit,
  getData,
  data,
  length,
  segments
}) => {

  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      {!isEdit && (
        <AddDefineLeaves
          toggle={toggle}
          open={open}
          getData={getData}
          length={length}
          // segments={segments}
        />
        
      )}
      {isEdit && (
        <EditDefineLeaves
          toggle={toggle}
          open={open}
          data={data}
          getData={getData}
          // segments={segments}
        />
      )}
    </Dialog>
  );
};

export default ToggleModal;
